module.exports = {
        srcSet: __webpack_public_path__ + "static/media/paper-and-pen-664.f98de9b4.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/paper-and-pen-664.f98de9b4.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/paper-and-pen-664.f98de9b4.webp",
        toString: function(){return __webpack_public_path__ + "static/media/paper-and-pen-664.f98de9b4.webp"},
        
        width: 664,
        height: 664
      }